import React from 'react';
import Error500 from '../../../../assets/icons/error500.svg';
import CommonErrorPage from '../CommonErrorPage/CommonErrorPage';
import { SERVER_ERROR_DESCRIPTION } from '../helpers/constants';

const ServerErrorPage = () => {
  const goToSupportPage = () => {
    window.location.href = ' https:// ';
  };

  return (
    <CommonErrorPage
      errorImage={Error500}
      title="Internal Server Error"
      description={SERVER_ERROR_DESCRIPTION}
      buttonText="Contact Support"
    />
  );
};

export default ServerErrorPage;
